import { BreakpointObserver, MediaMatcher } from '@angular/cdk/layout';
import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import { MatSidenav, MatSidenavContent } from '@angular/material/sidenav';
import { CoreService } from 'src/app/services/core.service';
import { AppSettings } from 'src/app/app.config';
import { filter } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { navItems } from './vertical/sidebar/sidebar-data';
import { NavService } from '../../services/nav.service';
import { AppNavItemComponent } from './vertical/sidebar/nav-item/nav-item.component';
import { RouterModule } from '@angular/router';
import { MaterialModule } from 'src/app/material.module';
import { CommonModule } from '@angular/common';
import { SidebarComponent } from './vertical/sidebar/sidebar.component';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { TablerIconsModule } from 'angular-tabler-icons';
import { HeaderComponent } from './vertical/header/header.component';
import { AppHorizontalHeaderComponent } from './horizontal/header/header.component';
import { AppHorizontalSidebarComponent } from './horizontal/sidebar/sidebar.component';
import { AppBreadcrumbComponent } from './shared/breadcrumb/breadcrumb.component';
import { CustomizerComponent } from './shared/customizer/customizer.component';
import { AuthService } from 'src/app/@auth/auth.service';
import { AppInfos, AuthSessionDto, BELOWMONITOR, MOBILE_VIEW, MONITOR_VIEW, ROLE_WORKSPACE_USER, ROLE_WORKSPACE_USER_LABELS, TABLET_VIEW } from 'src/app/app.models';
import { SidebarService } from './horizontal/sidebar/sidebar.service';
import { NavItem } from './vertical/sidebar/nav-item/nav-item';
import { CashDeskOptions } from 'src/app/@clu-fe/apps/m-cashdesk/@models/m-cashdesk-options.config';
import { CashDeskCoreOptionsService } from 'src/app/@clu-fe/apps/m-cashdesk/@services/m-cashdesk-core-options.service';
import { AppService } from 'src/app/services/app.service';
import { CluPermissionModule } from 'src/app/utils/clu-permission/clu-permission.module';
import { RemDocsCoreOptionsService } from 'src/app/@clu-fe/apps/m-remdocs/@services/m-remdocs-core-options.service';
import { RemDocsOptions } from 'src/app/@clu-fe/apps/m-remdocs/@models/m-remdocs-options.config';

// for mobile app sidebar
interface apps {
  id: number;
  img: string;
  title: string;
  subtitle: string;
  link: string;
  ON_TEST_ENV?: boolean; 
}

interface quicklinks {
  id: number;
  title: string;
  link: string;
}

@Component({
  selector: 'app-full',
  standalone: true,
  imports: [
    RouterModule,
    AppNavItemComponent,
    MaterialModule,
    CommonModule,
    SidebarComponent,
    NgScrollbarModule,
    TablerIconsModule,
    HeaderComponent,
    AppHorizontalHeaderComponent,
    AppHorizontalSidebarComponent,
    AppBreadcrumbComponent,
    CustomizerComponent,
    CluPermissionModule
  ],
  providers: [SidebarService],
  templateUrl: './full.component.html',
  styleUrls: [],
  encapsulation: ViewEncapsulation.None,
})
export class FullComponent implements OnInit {

  navItems: NavItem[] = [];

  @ViewChild('leftsidenav')
  public sidenav: MatSidenav;
  resView = false;
  @ViewChild('content', { static: true }) content!: MatSidenavContent;
  //get options from service
  options = this.settings.getOptions();
  private layoutChangesSubscription = Subscription.EMPTY;
  private isMobileScreen = false;
  private isContentWidthFixed = true;
  private isCollapsedWidthFixed = false;
  private htmlElement!: HTMLHtmlElement;

  get isOver(): boolean {
    return this.isMobileScreen;
  }

  get isTablet(): boolean {
    return this.resView;
  }

  // for mobile app sidebar
  apps: apps[] = [
    {
      id: 1,
      img: 'assets/images/svgs/module-caisse.png',
      title: 'Caisse',
      subtitle: 'Module caisse',
      link: '/apps/cashdesk/landing', 
      ON_TEST_ENV: true ,
    },
    {
      id: 2,
      img: 'assets/images/svgs/module-saisie.png',
      title: 'Saisie décentralisée',
      subtitle: 'Module saisie décentralisée',
      link: '/apps/remdocs/landing',
    }/*,
    {
      id: 3,
      img: 'assets/images/svgs/module-inventaire.png',
      title: 'Inventaire',
      subtitle: 'Module Inventaire',
      link: '/',
    },
    {
      id: 4,
      img: 'assets/images/svgs/module-mvts-caisse.png',
      title: 'Mouvements caisse',
      subtitle: 'Module caisse',
      link: '/',
    }*/
  ];

  quicklinks: quicklinks[] = [
    {
      id: 1,
      title: 'Pricing Page',
      link: '/theme-pages/pricing',
    },
    {
      id: 2,
      title: 'Authentication Design',
      link: '/authentication/side-login',
    },
    {
      id: 3,
      title: 'Register Now',
      link: '/authentication/side-register',
    },
    {
      id: 4,
      title: '404 Error Page',
      link: '/authentication/error',
    },
    {
      id: 5,
      title: 'Notes App',
      link: '/apps/notes',
    },
    {
      id: 6,
      title: 'Employee App',
      link: '/apps/employee',
    },
    {
      id: 7,
      title: 'Todo Application',
      link: '/apps/todo',
    },
    {
      id: 8,
      title: 'Treeview',
      link: '/theme-pages/treeview',
    },
  ];

  ROLE_WORKSPACE_USER_LABELS = ROLE_WORKSPACE_USER_LABELS;
  ROLE_WORKSPACE_USER = ROLE_WORKSPACE_USER;
  authSessionDto: AuthSessionDto;
  appVersion: AppInfos;

  activeModule : 'cashdesk' | 'remdocs' | undefined;
  cashDeskOptions : CashDeskOptions = this._cashDeskCoreOptionsService.getOptions();
  remDocsOptions : RemDocsOptions = this._remDocsCoreOptionsService.getOptions();
  constructor(
    private settings: CoreService,
    private _cashDeskCoreOptionsService : CashDeskCoreOptionsService,
    private _remDocsCoreOptionsService : RemDocsCoreOptionsService,
    private mediaMatcher: MediaMatcher,
    private router: Router,
    private breakpointObserver: BreakpointObserver,
    private navService: NavService,
    private authService: AuthService,
    sidebarService: SidebarService,
    appService: AppService,
  ) {
    this.appVersion = appService.appVersion$.value;
    this.navItems = sidebarService.getNavItems();
    this.htmlElement = document.querySelector('html')!; 
    this.layoutChangesSubscription = this.breakpointObserver
      .observe([MOBILE_VIEW, TABLET_VIEW, MONITOR_VIEW, BELOWMONITOR])
      .subscribe((state) => {
        // SidenavOpened must be reset true when layout changes
        this.options.sidenavOpened = true;
        this.isMobileScreen = state.breakpoints[MOBILE_VIEW];
        if (this.options.sidenavCollapsed == false) {
          this.options.sidenavCollapsed = state.breakpoints[TABLET_VIEW];
        }
        this.isContentWidthFixed = state.breakpoints[MONITOR_VIEW];
        this.resView = state.breakpoints[BELOWMONITOR];
      });

    // Initialize project theme with options
    this.receiveOptions(this.options);

    // This is for scroll to top
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((e) => {
        if(this.content) this.content.scrollTo({ top: 0 });
        this.doDetectActiveModule();
      });
    this.doDetectActiveModule();

    this.authSessionDto = authService.authenticatedSession$.value!;
    
    if (appService.isFrontofficeTestEnv) {
        this.apps = this.apps.filter(item => item.ON_TEST_ENV === true);
    }
  }

  ngOnInit(): void {}

  ngOnDestroy() {
    this.layoutChangesSubscription.unsubscribe();
  }

  doLogout() {
    if (this.authSessionDto.ROLE_ID == ROLE_WORKSPACE_USER.USER_WORKSPACE) {
      this.authService.doSignoutFOAction();
      this.authService.doRemoveAuthSession();
      this.router.navigateByUrl('/login');
    } else if (this.authSessionDto.ROLE_ID == ROLE_WORKSPACE_USER.ADMIN_WORKSPACE || this.authSessionDto.ROLE_ID == ROLE_WORKSPACE_USER.SUPER_ADMIN_WORKSPACE) {
      this.authService.doSignoutAdminAction();
      this.authService.doRemoveAuthSession();
      this.router.navigateByUrl("/cluadmin/login");
    } else {
      this.authService.doRemoveAuthSession();
      this.router.navigateByUrl('/login');
    }
  }


  toggleCollapsed() {
    this.isContentWidthFixed = false;
    this.options.sidenavCollapsed = !this.options.sidenavCollapsed;
    this.resetCollapsedState();
  }

  resetCollapsedState(timer = 400) {
    setTimeout(() => this.settings.setOptions(this.options), timer);
  }

  onSidenavClosedStart() {
    this.isContentWidthFixed = false;
  }

  onSidenavOpenedChange(isOpened: boolean) {
    this.isCollapsedWidthFixed = !this.isOver;
    this.options.sidenavOpened = isOpened;
    this.settings.setOptions(this.options);
  }

  receiveOptions(options: AppSettings): void {
    this.options = options;
    this.toggleDarkTheme(options);
  }

  toggleDarkTheme(options: AppSettings) {
    if (options.theme === 'dark') {
      this.htmlElement.classList.add('dark-theme');
      this.htmlElement.classList.remove('light-theme');
    } else {
      this.htmlElement.classList.remove('dark-theme');
      this.htmlElement.classList.add('light-theme');
    }
  }
  
  private doDetectActiveModule(){
    this.activeModule = this.router.url.includes('cashdesk') ? 'cashdesk' : this.router.url.includes('remdocs') ? 'remdocs' : undefined;
  }
}
